import styled from "styled-components";

const FlexBox = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Styled = {
    FlexBox,
};